export default __webpack_public_path__ + "static/media/delete_article.ec131db7.svg";